import { RankedTester, and, rankWith, optionIs, isControl } from "@jsonforms/core";

export const PriceInputTester: RankedTester = rankWith(10, and(isControl, optionIs("Price", true)));

export default PriceInputTester;
